import { createSelector } from 'reselect';
const selector = state => state.i18n;

export default createSelector([selector], data => data);